// import axios from './mock'
import axios from './http'
import urls from './urls'
// import { Toast } from 'vant'
import qs from 'qs'

export const getUserInfo = (params = {}) => {
  return axios.post(urls.user, qs.stringify(params))
}
export const loginSms = (params = {}) => {
  return axios.post(urls.loginSms, qs.stringify(params))
}
export const userLogin = (params = {}) => {
  return axios.post(urls.userLogin, qs.stringify(params))
}
export const contract = (params = {}) => {
  return axios.post(urls.contract, qs.stringify(params))
}
export const userInfo = (params = {}) => {
  return axios.post(urls.userInfo, qs.stringify(params))
}
export const authent = (params = {}) => {
  return axios.post(urls.authent, qs.stringify(params))
}
export const contractSuccess = (params = {}) => {
  return axios.post(urls.contractSuccess, qs.stringify(params))
}
export const sendEmail = (params = {}) => {
  return axios.post(urls.sendEmail, qs.stringify(params))
}
